export type HeadItemEl = HTMLElement & { width?: number | null };

export type PrefixColumn = {
  colNumber: number;
  left: number;
  right: number;
};